import React from 'react'
import Contact from '../components/Contact'
import SEOHead from '../components/SEOHead'

const ContactPage: React.FC = () => {
  return (
    <div>
      <SEOHead
        title="Contact Fast Boat Trailers - Get Your Quote Today | Edgewater MD"
        description="Contact Fast Boat Trailers in Edgewater, MD for boat trailer quotes, custom builds, and expert marine transport advice. Call 410-570-9150 or request a quote online."
        keywords="contact fast boat trailers, boat trailer quotes, Edgewater MD trailers, 410-570-9150, custom boat trailers, marine transport quotes"
        ogTitle="Contact Fast Boat Trailers - Get Your Quote Today"
        ogDescription="Contact Fast Boat Trailers in Edgewater, MD for boat trailer quotes and expert marine transport advice. Call 410-570-9150 or request online."
        ogImage="/images/logos/fbt-logo-3-noborder.jpeg"
        canonical="https://fastboattrailers.com/contact"
      />
      <Contact />
    </div>
  )
}

export default ContactPage